import { render, staticRenderFns } from "./RarityFilter.vue?vue&type=template&id=2f6fd818"
import script from "./RarityFilter.vue?vue&type=script&lang=js"
export * from "./RarityFilter.vue?vue&type=script&lang=js"
import style0 from "./RarityFilter.vue?vue&type=style&index=0&id=2f6fd818&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports